export const HELP_CENTER_BASE_URL =
  'https://help.insights.numerator.com/en/collections/15743024-narrative';

export const HELP_CENTER_NARRATIVE_URLS = {
  'brand-defense':
    'https://help.insights.numerator.com/en/articles/12622587-about-the-brand-defense-narrative',
  'brand-sell-in':
    'https://help.numerator.com/en/articles/13551752-about-the-brand-sell-in-narrative',
  'category-review':
    'https://help.insights.numerator.com/en/articles/12622629-about-the-category-review-narrative',
  'diagnosing-growth':
    'https://help.numerator.com/en/articles/13551755-about-the-diagnosing-growth-narrative',
  incrementality:
    'https://help.numerator.com/en/articles/13551757-about-the-incrementality-narrative',
  'who-is-my-shopper':
    'https://help.insights.numerator.com/en/articles/12622642-about-the-who-s-my-shopper-narrative',
};
